/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';
import SettingsNav from 'settings/components/SettingsNav';
import CurrentUser from 'auth/CurrentUser';

type State = {
  canOwnGroups: boolean,
};

class SettingsNavContainer extends React.Component<{}, State> {
  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    const user = CurrentUser.getUser();
    const canOwnGroups = user.canOwnGroups();

    return {
      canOwnGroups,
    };
  }

  render() {
    return <SettingsNav {...this.state} />;
  }
}

export default Container.create(SettingsNavContainer);
